import { util } from 'echarts/core';
import { normalizeToArray } from '../../../util/utils';
import { type ThemeParser } from '../../../core/theme';

function parseGrid(option: Parameters<ThemeParser>[0]) {
  const DEFAULT_GRID = {
    left: 16,
    top: 18,
    bottom: 18,
    right: 16,
    height: 160
  };
  option.grid = normalizeToArray(option.grid || {});

  option.grid.forEach(el => {
    el = util.merge(el, DEFAULT_GRID);
  });
}

export function GridThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];
  parseGrid(option);
}
